import React, { useState } from 'react';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../style/color';
import axios from 'axios';
import { mainurl } from '../../Mainurl';
import Switch from '@mui/material/Switch';
import { notification } from '../../component/hocs/notification';

import AddUser from '../../component/utility/master/AddUser';
import AssignUser from '../../component/utility/master/AssignUser';
import AssignUserView from '../../component/utility/master/AssignUserView';

import {
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Button,
    Input,
    InputGroup,
    InputGroupText,
    Badge,
    Spinner,
    Alert,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';
import {
    FaEdit,
    FaPlusCircle,
    FaClipboardList,
    FaUsers,
    FaSearch,
    FaUserCheck,
    FaUserTimes,
    FaEllipsisV,
    FaEye,
    FaUserPlus,
    FaFilter
} from 'react-icons/fa';
import { MdAssignmentTurnedIn } from 'react-icons/md';

const UserManagement = () => {
    const [mode, setMode] = useState(1);
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [crrUser, setCrrUser] = useState('');
    const [filterDropdown, setFilterDropdown] = useState(false);
    const [statusFilter, setStatusFilter] = useState('all');

    const user_list = async () => {
        setLoading(true);
        setTableData([]);
        setFilteredData([]);

        try {
            let postData = [{
                "org_id": sessionStorage.getItem('org_id'),
                "user_id": sessionStorage.getItem('user_id')
            }];

            const response = await axios({
                method: 'post',
                url: mainurl + 'Master/box_user_list',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            let list = response.data.map((row, index) => {
                let active = row.active_flag === "1";
                return {
                    ids: index + 1,
                    name: row.user_name + " (" + row.user_name_ne + ")",
                    mobile: row.user_phone,
                    email: row.user_email,
                    user_id: row.user_code,
                    designation: row.role_desc,
                    status: active,
                    active_flag: row.active_flag,
                    action: (
                        <div className="d-flex align-items-center gap-2">
                            <Button
                                color="info"
                                size="sm"
                                outline
                                className="d-flex align-items-center gap-1"
                                onClick={() => user_assign_view_handler(row)}
                                title="View Details"
                            >
                                <FaEye size={12} />
                                View
                            </Button>
                            <Switch
                                checked={active}
                                size="small"
                                color="success"
                                onChange={(e) => handleStatusToggle(row, e.target.checked)}
                            />
                        </div>
                    ),
                    rawData: row
                };
            });

            setTableData(list);
            setFilteredData(list);

            let notify = notification({
                message: `${list.length} users loaded successfully`,
                type: 'success'
            });
            notify();
        } catch (error) {
            let notify = notification({
                message: "User list not found! Try Again",
                type: 'error'
            });
            notify();
        } finally {
            setLoading(false);
        }
    };

    const handleStatusToggle = async (user, newStatus) => {
        // Add your status toggle API call here
        console.log('Toggle status for user:', user.user_code, 'to:', newStatus);
        // You can implement the actual API call to update user status
    };

    const user_assign_view_handler = (row) => {
        setCrrUser(row);
        setMode(4);
    };

    const back_handler = () => {
        setMode(1);
        // Refresh data when coming back
        if (tableData.length === 0) {
            user_list();
        }
    };

    // Search functionality
    const handleSearch = (value) => {
        setSearchTerm(value);
        applyFilters(value, statusFilter);
    };

    const handleStatusFilter = (filter) => {
        setStatusFilter(filter);
        applyFilters(searchTerm, filter);
    };

    const applyFilters = (search, status) => {
        let filtered = tableData;

        // Apply search filter
        if (search !== '') {
            filtered = filtered.filter(item =>
                item.name.toLowerCase().includes(search.toLowerCase()) ||
                item.mobile.includes(search) ||
                item.email.toLowerCase().includes(search.toLowerCase()) ||
                item.user_id.toLowerCase().includes(search.toLowerCase()) ||
                item.designation.toLowerCase().includes(search.toLowerCase())
            );
        }

        // Apply status filter
        if (status !== 'all') {
            const isActive = status === 'active';
            filtered = filtered.filter(item => item.status === isActive);
        }

        setFilteredData(filtered);
    };

    const getActiveUsersCount = () => tableData.filter(user => user.status).length;
    const getInactiveUsersCount = () => tableData.filter(user => !user.status).length;

    const columns = [
        {
            name: '#',
            selector: row => row.ids,
            sortable: true,
            width: '70px',
            center: true
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaUsers size={12} />
                    Name
                </div>
            ),
            selector: row => row.name,
            sortable: true,
            width: "25%",
            cell: row => (
                <div className="d-flex align-items-center gap-2">
                    <div className="user-avatar bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" 
                         style={{ width: '32px', height: '32px', fontSize: '12px' }}>
                        {row.name.charAt(0).toUpperCase()}
                    </div>
                    <div>
                        <div className="fw-medium">{row.name.split('(')[0].trim()}</div>
                        <small className="text-muted">{row.name.match(/\((.*?)\)/)?.[1] || ''}</small>
                    </div>
                </div>
            )
        },
        {
            name: 'Mobile',
            selector: row => row.mobile,
            sortable: true,
            cell: row => (
                <span className="text-nowrap">{row.mobile || 'N/A'}</span>
            )
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
            cell: row => (
                <div className="text-truncate" title={row.email}>
                    {row.email || 'N/A'}
                </div>
            )
        },
        {
            name: 'Login ID',
            selector: row => row.user_id,
            sortable: true,
            cell: row => (
                <Badge color="light" className="text-primary" pill>
                    {row.user_id}
                </Badge>
            )
        },
        {
            name: 'Designation',
            selector: row => row.designation,
            sortable: true,
            cell: row => (
                <Badge color={row.designation ? 'secondary' : 'light'} pill>
                    {row.designation || 'Not Assigned'}
                </Badge>
            )
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
            center: true,
            cell: row => (
                <Badge color={row.status ? 'success' : 'danger'} pill>
                    {row.status ? 'Active' : 'Inactive'}
                </Badge>
            )
        },
        {
            name: 'Actions',
            selector: row => row.action,
            sortable: false,
            center: true,
            width: '200px'
        }
    ];

    return (
        <>
            <Header />
            <Page title='User Management' breadcrumbs='Home / User Management'>
                <Row className='p-3'>
                    {mode === 1 && (
                        <Col xs={12}>
                            {/* Action Bar */}
                            <Card className='mb-4 border-0 shadow-sm'>
                                <CardBody className="py-3">
                                    <Row className="align-items-center">
                                        <Col md={6}>
                                            <div className="d-flex gap-2">
                                                <Button
                                                    color='primary'
                                                    size="sm"
                                                    onClick={user_list}
                                                    disabled={loading}
                                                    className="d-flex align-items-center gap-2"
                                                >
                                                    {loading ? (
                                                        <Spinner size="sm" />
                                                    ) : (
                                                        <FaClipboardList size={14} />
                                                    )}
                                                    {loading ? 'Loading...' : 'Load Users'}
                                                </Button>
                                                <Button
                                                    color='success'
                                                    size="sm"
                                                    onClick={() => setMode(2)}
                                                    className="d-flex align-items-center gap-2 text-white"
                                                >
                                                    <FaPlusCircle size={14} />
                                                    Add New User
                                                </Button>
                                                <Dropdown
                                                    isOpen={filterDropdown}
                                                    toggle={() => setFilterDropdown(!filterDropdown)}
                                                >
                                                    <DropdownToggle
                                                        color="secondary"
                                                        size="sm"
                                                        outline
                                                        className="d-flex align-items-center gap-2"
                                                        caret
                                                    >
                                                        <FaFilter size={12} />
                                                        Filter
                                                    </DropdownToggle>
                                                    <DropdownMenu>
                                                        <DropdownItem
                                                            active={statusFilter === 'all'}
                                                            onClick={() => handleStatusFilter('all')}
                                                        >
                                                            All Users
                                                        </DropdownItem>
                                                        <DropdownItem
                                                            active={statusFilter === 'active'}
                                                            onClick={() => handleStatusFilter('active')}
                                                        >
                                                            Active Only
                                                        </DropdownItem>
                                                        <DropdownItem
                                                            active={statusFilter === 'inactive'}
                                                            onClick={() => handleStatusFilter('inactive')}
                                                        >
                                                            Inactive Only
                                                        </DropdownItem>
                                                    </DropdownMenu>
                                                </Dropdown>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <InputGroup size="sm">
                                                <InputGroupText className="bg-light border-end-0">
                                                    <FaSearch className="text-muted" />
                                                </InputGroupText>
                                                <Input
                                                    type="search"
                                                    placeholder='Search users, email, mobile, designation...'
                                                    value={searchTerm}
                                                    onChange={(e) => handleSearch(e.target.value)}
                                                    className="border-start-0"
                                                />
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>

                            {/* Statistics Cards */}
                            {tableData.length > 0 && (
                                <Row className="mb-4">
                                    <Col md={3}>
                                        <Card className="border-0 bg-primary text-white">
                                            <CardBody className="text-center py-3">
                                                <FaUsers size={24} className="mb-2" />
                                                <h5 className="mb-0">{tableData.length}</h5>
                                                <small>Total Users</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-success text-white">
                                            <CardBody className="text-center py-3">
                                                <FaUserCheck size={24} className="mb-2" />
                                                <h5 className="mb-0">{getActiveUsersCount()}</h5>
                                                <small>Active Users</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-warning text-white">
                                            <CardBody className="text-center py-3">
                                                <FaUserTimes size={24} className="mb-2" />
                                                <h5 className="mb-0">{getInactiveUsersCount()}</h5>
                                                <small>Inactive Users</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-info text-white">
                                            <CardBody className="text-center py-3">
                                                <MdAssignmentTurnedIn size={24} className="mb-2" />
                                                <h5 className="mb-0">
                                                    {Math.round((getActiveUsersCount() / tableData.length) * 100)}%
                                                </h5>
                                                <small>Activity Rate</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            )}

                            {/* Main Data Table */}
                            <Card className='border-0 shadow-sm'>
                                <CardHeader className="bg-white border-bottom">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h5 className="mb-0">User Records</h5>
                                            <small className='text-muted'>
                                                {filteredData.length > 0 ?
                                                    `Showing ${filteredData.length} of ${tableData.length} users` :
                                                    'No users found'
                                                }
                                            </small>
                                        </div>
                                        {(searchTerm || statusFilter !== 'all') && (
                                            <div className="d-flex gap-2">
                                                {searchTerm && (
                                                    <Badge color="secondary">
                                                        Search: "{searchTerm}"
                                                    </Badge>
                                                )}
                                                {statusFilter !== 'all' && (
                                                    <Badge color="info">
                                                        {statusFilter === 'active' ? 'Active Users' : 'Inactive Users'}
                                                    </Badge>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </CardHeader>
                                <CardBody className="p-0">
                                    {tableData.length === 0 && !loading ? (
                                        <Alert color="info" className="m-3 text-center">
                                            <FaUsers size={48} className="mb-3 text-muted" />
                                            <p className="mb-2">No users loaded yet</p>
                                            <small>Click "Load Users" to fetch the latest user data</small>
                                        </Alert>
                                    ) : (
                                        <DataTable
                                            title=""
                                            customStyles={custTableStyles}
                                            columns={columns}
                                            data={filteredData}
                                            highlightOnHover
                                            responsive
                                            pagination
                                            paginationPerPage={10}
                                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                            progressPending={loading}
                                            progressComponent={
                                                <div className="d-flex flex-column align-items-center justify-content-center py-5">
                                                    <Spinner color="primary" />
                                                    <p className="mt-2 text-muted">Loading users...</p>
                                                </div>
                                            }
                                            noDataComponent={
                                                <div className="text-center py-5">
                                                    <FaSearch size={48} className="text-muted mb-3" />
                                                    <p className="text-muted">No users match your search criteria</p>
                                                    {(searchTerm || statusFilter !== 'all') && (
                                                        <Button
                                                            color="link"
                                                            size="sm"
                                                            onClick={() => {
                                                                setSearchTerm('');
                                                                setStatusFilter('all');
                                                                setFilteredData(tableData);
                                                            }}
                                                        >
                                                            Clear filters
                                                        </Button>
                                                    )}
                                                </div>
                                            }
                                        />
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    )}

                    {mode === 2 && (
                        <Col xs={12}>
                            <Card className="border-0 shadow-sm">
                                <CardHeader className="bg-light border-bottom">
                                    <div className="d-flex align-items-center gap-2">
                                        <FaUserPlus className="text-primary" />
                                        <h5 className="mb-0">Add New User</h5>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    <AddUser 
                                        back={() => back_handler()} 
                                        reset={() => {
                                            user_list();
                                            setMode(1);
                                        }} 
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    )}

                    {mode === 3 && (
                        <Col xs={12}>
                            <Card className="border-0 shadow-sm">
                                <CardHeader className="bg-light border-bottom">
                                    <div className="d-flex align-items-center gap-2">
                                        <MdAssignmentTurnedIn className="text-primary" />
                                        <h5 className="mb-0">Assign User</h5>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    <AssignUser back={() => back_handler()} />
                                </CardBody>
                            </Card>
                        </Col>
                    )}

                    {mode === 4 && (
                        <Col xs={12}>
                            <Card className="border-0 shadow-sm">
                                <CardHeader className="bg-light border-bottom">
                                    <div className="d-flex align-items-center gap-2">
                                        <FaEye className="text-primary" />
                                        <div>
                                            <h5 className="mb-0">User Details</h5>
                                            <small className="text-muted">
                                                {crrUser?.user_name} ({crrUser?.user_code})
                                            </small>
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    <AssignUserView user={crrUser} back={() => back_handler()} />
                                </CardBody>
                            </Card>
                        </Col>
                    )}
                </Row>
            </Page>
            <Footer />
        </>
    );
};

export default UserManagement;